import AOS from 'aos';

const selectors = {
  tabs: '[data-size-guide-tab]',
  panels: '[data-size-guide-panel]',
  unitToggle: '[data-size-guide-unit-toggle]',
  unitBtn: '[data-size-guide-unit-btn]',
};

const classes = {
  tabInactive: ['bg-transparent', 'text-black'],
  tabActive: ['bg-black', 'text-white'],
  unitBtnActive: ['border-current'],
  unitBtnInactive: ['border-transparent'],
};

export default class DynamicSizeGuide {
  constructor(section) {
    this.el = section.el;
    this.section = section;
    this.tabs = [];
    this.panels = [];
    this.init();
  }

  init() {
    const container = this.el.querySelector('[data-size-guide-panels]');
    if (!container) {
      return;
    }

    this.tabs = [...this.el.querySelectorAll(selectors.tabs)];
    this.panels = [...container.querySelectorAll(selectors.panels)];

    if (this.tabs.length === 0 || this.panels.length === 0) {
      return;
    }

    this._setActiveByBlockId(this.tabs[0]?.dataset.blockId);
    this._bindTabs();
    this._bindUnitToggles();

    AOS.refresh();
  }

  _bindTabs() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const blockId = tab.dataset.blockId;
        if (blockId) {
          this._setActiveByBlockId(blockId);
        }
      });
    });
  }

  _bindUnitToggles() {
    const unitToggles = this.el.querySelectorAll(selectors.unitToggle);
    unitToggles.forEach(toggle => {
      toggle.addEventListener('click', this._onUnitToggleClick);
    });
  }

  _onUnitToggleClick = e => {
    const btn = e.target;
    const unit = btn.dataset.sizeGuideUnitBtn;
    if (!unit) {
      return;
    }

    const toggle = btn.closest(selectors.unitToggle);
    const panel = toggle?.closest(selectors.panels);
    if (!panel) {
      return;
    }

    this._setUnit(panel, unit);
  };

  _setUnit(panel, unit) {
    const toggle = panel.querySelector(selectors.unitToggle);
    if (!toggle) {
      return;
    }

    const btns = toggle.querySelectorAll(selectors.unitBtn);
    const inchCells = panel.querySelectorAll('[data-size-guide-unit="in"]');
    const cmCells = panel.querySelectorAll('[data-size-guide-unit="cm"]');

    const showInches = unit === 'in';

    btns.forEach(btn => {
      const isActive = btn.dataset.sizeGuideUnitBtn === unit;
      btn.setAttribute('aria-pressed', String(isActive));
      if (isActive) {
        btn.classList.add(classes.unitBtnActive);
        btn.classList.remove(classes.unitBtnInactive);
      } else {
        btn.classList.add(classes.unitBtnInactive);
        btn.classList.remove(classes.unitBtnActive);
      }
    });

    inchCells.forEach(cell => cell.classList.toggle('hidden', !showInches));
    cmCells.forEach(cell => cell.classList.toggle('hidden', showInches));
  }

  _setActiveByBlockId(blockId) {
    // Update tab states
    this.tabs.forEach(tab => {
      const isActive = tab.dataset.blockId === blockId;
      tab.setAttribute('aria-selected', String(isActive));
      if (isActive) {
        tab.classList.add(...classes.tabActive);
        tab.classList.remove(...classes.tabInactive);
      } else {
        tab.classList.add(...classes.tabInactive);
        tab.classList.remove(...classes.tabActive);
      }
    });

    // Update panel visibility
    this.panels.forEach(panel => {
      const isActive = panel.dataset.blockId === blockId;
      panel.classList.toggle('hidden', !isActive);
    });
  }

  onSectionUnload() {
    this.el.removeEventListener('click', this._onUnitToggleClick);
    this.tabs = [];
    this.panels = [];
  }
}
